const GET_OFFICE_LIST = 'GET_OFFICE_LIST'
const GET_OFFICE_LIST_SUCCESS = 'GET_OFFICE_LIST_SUCCESS'

export { GET_OFFICE_LIST, GET_OFFICE_LIST_SUCCESS }
